import { render, staticRenderFns } from "./RiskInformationQuotator.vue?vue&type=template&id=d4c87c1a&scoped=true&"
import script from "./RiskInformationQuotator.vue?vue&type=script&lang=js&"
export * from "./RiskInformationQuotator.vue?vue&type=script&lang=js&"
import style0 from "./RiskInformationQuotator.vue?vue&type=style&index=0&id=d4c87c1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c87c1a",
  null
  
)

export default component.exports